<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">Enroll in PSP</h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request" id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar  [step]="15" [totalSteps]="19"></app-complete-bar >
               <h2 [innerHTML]="'CERT_1' | translator:'base'">CERTIFICATIONS</h2>
               <fieldset>
                 <legend class="mb-3" [innerHTML]="'CERT_2' | translator:'base'">Please review the certifications. To accept, click on the option below and then click "Agree".</legend>
                 <hr>
                 <div class="frame_holder">
                   <div class="scroll_frame bg-light border p-3 overflow-auto">
                     <div [innerHTML]="loadFile">
   
                     </div>
                   </div>
                 </div>
                 <div class="form-group pt-3">
                   <div class="form-check">
                     <label class="form-check-label">
                       <input type="radio" name="ReadAgreement" id="agreeReadAgreement20" class="form-check-input" [(ngModel)]="enrollmentService.newCustomer!.eulaAgreement!.readCerts" value="agree">
                       <span [innerHTML]="'CERT_2_a' | translator:'base'">I have read and agree to these certifications and am authorized to sign on behalf of the monthly account holder.</span>
                     </label>
                   </div>
                   <div class="form-check">
                     <label class="form-check-label">
                       <input id="disagreeReadAgreement20" class="form-check-input" type="radio" name="ReadAgreement" [(ngModel)]="enrollmentService.newCustomer!.eulaAgreement!.readCerts" value="---">
                       <span [innerHTML]="'CERT_3' | translator:'base'">I disagree with these certifications.</span>
                     </label>
                   </div>
                 </div>
               </fieldset>
               <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                 <div class="btn-group" role="group">
                   <button routerLink="/signup/20" (click)="scrollToTop()" [disabled]="!pageValid()" class="btn btn-primary btn-strong" [title]="'CERT_4' | translator:'base'" name="companyNext20" id="companyNext20">
                     <span [innerHTML]="'Agree' | translator:'base'">Agree</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'CERT_4' | translator:'base'">Disclosure &amp; Authorization</span>
                   </button>
                 </div>
                 <div class="btn-group" role="group">
                   <a routerLink="/signup/18" class="btn btn-outline-primary" [title]="'CERT_5' | translator:'base'" name="companyBack20" id="companyBack20" (click)="scrollToTop()">
                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'CERT_5' | translator:'base'">Terms &amp; Conditions</span>
                   </a>
                   <a routerLink="/" class="btn btn-light" (click)="scrollToTop()" name="companyCancel2" id="companyCancel2" [innerHTML]="'Cancel' | translator:'base'" [title]="'Cancel' | translator:'base'"></a>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="5"
         [pageType]="enrollmentService.newCustomer!.customerType || '-'"
         class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
       </div>
     </div>
    <app-spinner
      [isLoading] = isLoading
    ></app-spinner>
   </div>
   
